import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EntitlementsHelperService } from '@ptl/account-management';
import {
  HTTPWrapperContext,
  RequestConfig,
  RequestConfigImplementation,
  REQUEST_METHODS,
  XHR_STRATEGIES,
  AxwayTokenFetcherService
} from '@ptl/xhr';
import { GlobalDataStateStructure } from 'src/app/angular-elements/shared/components/configs/interfaces/globalStateStructure.interface';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { ACCESS_TYPE } from '../configs/enums/access-type.enum';
import {
  HealthSherpaViaAgentCubed,
  HealthSherpaViaRetention,
  HealthSherpaViaNewQuote
} from '../configs/interfaces/health-sherpa-session-request.interface';
import { environment } from 'src/environments/environment';
import { RedirectService } from 'src/app/angular-elements/shared/services/redirect.service';
import { API_ENDPOINTS} from '../../../../../shared/constants/api-endpoints.constant';

@Injectable({
  providedIn: 'root'
})
export class HealthSherpaSSOService {

  constructor(
    private httpService: HTTPWrapperContext,
    private reducerUtilityService: ReducerUtilityService,
    private entitlementsHelperService: EntitlementsHelperService,
    private redirectService: RedirectService,
    private axwayTokenFetcherService: AxwayTokenFetcherService
  ) { }

  /**
   * 1) Agent Cubed - get data from state
   * 2) RetentionId - pass data from component
   * 3) New Quote - no additional data needed
   */
  async preSSORequest(
    accessType: ACCESS_TYPE,
    retentionId?: number
  ): Promise<any> {

    /** Build PAYLOAD */
    let payload: HealthSherpaViaAgentCubed | HealthSherpaViaRetention | HealthSherpaViaNewQuote = null;

    switch (accessType) {
      case ACCESS_TYPE.AGENT_CUBED:

        const globalData: GlobalDataStateStructure = this.reducerUtilityService.getState('GlobalData');

        if (
          globalData?.urlParams?.customerId &&
          globalData?.urlParams?.opportunityId
        ) {
          payload = {
            accessType,
            customerId: globalData.urlParams.customerId,
            opportunityId: globalData.urlParams.opportunityId
          };
        }
        break;

      case ACCESS_TYPE.CURRENTLY_ENROLLED:

        payload = {
          accessType,
          retensionId: retentionId
        };
        break;

      case ACCESS_TYPE.NEW_QUOTE:

        payload = {
          accessType
        };
        break;

    }

    /** Build URL */

    const selectedAgency = await this.entitlementsHelperService.getSelectedAgencyPromise();
    const agencyID = selectedAgency.agencyId;

    /** Build REQUEST */
    const config: RequestConfig = {
      method: REQUEST_METHODS.POST,
      url: this.axwayTokenFetcherService.buildApiUrl(API_ENDPOINTS.SECURE_APP.HEALTHSHARPA, { partyId: agencyID }),
      POST_OR_PUT_PAYLOAD: payload
    };

    const impl: RequestConfigImplementation = new RequestConfigImplementation(config);
    this.httpService.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS_V4);
    return this.httpService.makeRequest<any>(impl);

  }

  async doSSO(
    accessType: ACCESS_TYPE,
    retentionId?: number
  ): Promise<boolean> {

    /** Validate format with backend - it does some table population and stuff */
    const validationRequestResponse = await this.preSSORequest(accessType, retentionId);

    /** If validated, go ahead with SSO */
    if (!(validationRequestResponse instanceof HttpErrorResponse)) {
      const destinationURL = 'HEALTHSHERPASSO';
      const target = 'https://' + environment.external.vendors.agentCubeUrl;
      const postParams = {
        destinationURL,
        target
      };
      this.redirectService.post(postParams);
      return true;
    } else {
      return false;
    }
  }
}
